import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.scss";
import Nav from "./Component/nav/index"; //navigation bar path
import Footer from "./Component/footer/Footer"; // Import the footer
import Home from "./Component/pages/Home/home"; // Ensure correct path from home page
// import CareerAssessment from "./Component/pages/SkillsphereAssessment/CareerAssessment";
import Contact from "./Component/pages/Contact/contact";
import TnC from "./Component/pages/terms-and-conditions";
import PrivacyPolicy from "./Component/pages/privacy-policy";
import Nextgen from "./Component/pages/NextgenInnovator/Nextgen";
import AboutUs from "./Component/pages/AboutUs/AboutUs";
import AboutOurValue from "./Component/pages/AboutUs/OurValue";
import NextgenJuniors from "./Component/pages/NextgenJuniors/NextgenJunior";
import NextgenPlacement from "./Component/NextgenPlacement/NextgenPlacement";
import Contact_Us from "./Component/pages/Contact/Contact-Us/Contact_Us";
import Blog from "./Component/pages/Blog's/Blog";
import Login from "./Component/admin/Login";
import Dashboard from "./Component/admin/DashBoard";
import BlogRegister from "./Component/admin/BlogRegister";
import ProtectedRoute from "./Component/ProtectedRoute";
import Ocean from "./Component/pages/models/Ocean";
import Baronmodel from "./Component/pages/models/Bar_on_model";
import Raisec from "./Component/pages/models/Riasec";
import Describestory from "./Component/pages/Blog's/DescribeStory";
import Core from "./Component/pages/models/Core"
import NEP from "./Component/pages/models/NEP";
import Dat from "./Component/pages/models/Dat"
import JobregisterPage from "./Component/admin/JobRegister"
import AboutTheCompany from "./Component/pages/FAQ/Aboutthecompany";
import FAQnextgeni from "./Component/pages/FAQ/FAQnextgenI";
import FAQnextgenj from "./Component/pages/FAQ/FAQnextgenj";
import FAQskillsphere from "./Component/pages/FAQ/FAQskillsphere";
import Career  from "./Component/pages/careers/Careers_page";
import JOb_Details  from "./Component/pages/careers/Job_Details";
import Testimonialsumbit from "./Component/admin/Testimonial_Sumbit";
import SteamPage_main from "./Component/pages/steam/SteamPage_main";
import FAQ from "./Component/pages/FAQ/FQAHome";
import FaqregisterPage from "./Component/admin/FaqregisterPage";
import Fellowship from "./Component/pages/Fellowship/Fellowship";
import Globalline from "./Component/pages/global expo/Globalline"
// import LMS from "./Component/pages/LMS/LMS";
import EntrepreneurshipLeague from "./Component/pages/Clubs/EntrepreneurshipLeague";
import MedicalMavericks from "./Component/pages/Clubs/MedicalMavericks";
import ArtisticVisionaries from "./Component/pages/Clubs/ArtisticVisionaries";
import EngineeringExplorers from "./Component/pages/Clubs/EngineeringExplorers";
import AdministrativeAchievers from "./Component/pages/Clubs/AdministrativeAchievers";
import BusinessTrailblazers from "./Component/pages/Clubs/BusinessTrailblazers";
import SkillSphere from "./Component/pages/Skillsphere/Skillsphere";
import Sample from "./Component/pages/Skillsphere/Sample";
import Packages from './Component/pages/Skillsphere/Pricing'
import NextgenCampusHome from "./Component/pages/NextgenCampus/NextgenCampusHome";
function App() {
  return (
    <>
      {/* <Router> */}
      {/* <Nav />
        <Routes>
          <Route path="/student" element={<Home />} />
          <Route path="/about" element={<Contact />} />
          <Route path="/skillsphere-assessment" element={<CareerAssessment />} />
          <Route path="/terms-and-conditions" element={<TnC />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* <Route path="/skills" element={<Skills />} /> */}
      {/* <Route path="/nextgeni" element={<Nextgen />} />
          <Route path="/about-us" element={<AboutUs />} />
        <Route path="/about-ourvalue" element={<AboutOurValue/>} />
          <Route path="/nextgenj" element={<NextgenJuniors />} />
          <Route path="/refer-earn" element={<ReferPage />} />
          <Route path="/contact" element={<Contact_Us />} />
          <Route path="/blog" element={<Blog/>} />
          {/* <Route path="/JOb_Details" element={<JOb_Details />} /> */}
      {/* <Route path="/login" element={<Login/>} />
        </Routes>
        <Footer /> */}
        
      <Router>
        <Routes>
          {/* Home */}
          <Route
            path="/home"
            element={
              <>
                <Nav />
                <Home />
                <Footer />
              </>
            }
          />

<Route
            path="/campus"
            element={
              <>
                <Nav />
                <NextgenCampusHome/>
                <Footer />
              </>
            }
          />
          <Route
            path="/job_details"
            element={
              <>
                <Nav />
                <JOb_Details/>
                <Footer />
              </>
            }
          />
          <Route
            path="/campus"
            element={
              <>
                <Nav />
                <NextgenCampusHome/>
                <Footer />
              </>
            }
          />


          {/* About */}
          <Route
            path="/nextgenPlacement"
            element={
              <>
                <Nav />
                <NextgenPlacement/>
                <Footer />
              </>
            }
          />
           <Route
            path="/career"
            element={
              <>
                <Nav />
                <Career />
                <Footer />
              </>
            }
          />
          <Route
            path="/career"
            element={
              <>
                <Nav />
                <Career />
                <Footer />
              </>
            }
          />
          {/* <Route
            path="/placement"
            element={
              <>
                <Nav />
                <Placement />
                <Footer />
              </>
            }
          /> */}
           {/* LMS */}
           {/* <Route
            path="/lms"
            element={
              <>
                <Nav />
                <LMS/>
                <Footer />
              </>
            }
          /> */}

<Route
            path="/fellowship"
            element={
              <>
                <Nav />
                <Fellowship/>
                <Footer />
              </>
            }
          />
                    
<Route
            path="/"
            element={
              <>
                <Nav />
                <SkillSphere /> 
                <Footer />
              </>
            }
          /> 
           <Route
            path="/Global"
            element={
              <>
                <Nav />
                <Globalline />
                <Footer />
              </>
            }
          />
          <Route
            path="/ocean"
            element={
              <>
                <Nav />
                <Ocean />
                <Footer />
              </>
            }
          />
     <Route
            path="/Packages"
            element={
              <>
                <Nav />
                <Packages />
                <Footer />
              </>
            }
          />

<Route
            path="/entrepreneurship"
            element={
              <>
                <Nav />
                <EntrepreneurshipLeague/>
                <Footer />
              </>
            }
          />
           
           <Route
            path="/medicalmavericks"
            element={
              <>
                <Nav />
                <MedicalMavericks/>
                <Footer />
              </>
            }
          />
          <Route
            path="/artisticvisionaries"
            element={
              <>
                <Nav />
                <ArtisticVisionaries/>
                <Footer />
              </>
            }
          />
           
           <Route
            path="/engineeringexplorers"
            element={
              <>
                <Nav />
                <EngineeringExplorers/>
                <Footer />
              </>
            }
          />

          <Route
            path="/engineeringexplorers"
            element={
              <>
                <Nav />
                <EngineeringExplorers/>
                <Footer />
              </>
            }
          />

<Route
            path="/administrativeAchievers"
            element={
              <>
                <Nav />
                <AdministrativeAchievers/>
                <Footer />
              </>
            }
          />
          <Route
            path="/businesstrailbazars"
            element={
              <>
                <Nav />
                <BusinessTrailblazers/>
                <Footer />
              </>
            }
          />

          <Route
            path="/describestory"
            element={
              <>
                <Nav />
                <Describestory />
                <Footer />
              </>
            }
          />

<Route
            path="/aoc"
            element={
              <>
                <Nav />
                <AboutTheCompany/>
                <Footer />
              </>
            }
          />

<Route
            path="/faqnextgeni"
            element={
              <>
                <Nav />
                <FAQnextgeni />
                <Footer />
              </>
            }
          />

<Route
            path="/faqnextgenj"
            element={
              <>
                <Nav />
                <FAQnextgenj />
                <Footer />
              </>
            }
          />

            <Route
            path="/faqskillsphere"
            element={
              <>
                <Nav />
                <FAQskillsphere/>
                <Footer />
              </>
            }
          />

          <Route
            path="/nep"
            element={
              <>
                <Nav />
                <NEP />
                <Footer />
              </>
            }
          />

           <Route
            path="/faq"
            element={
              <>
                <Nav />
                <FAQ/>
                <Footer />
              </>
            }
          />

          {/* SkillSphere Assessment
          <Route
            path="/skillsphere-assessment"
            element={
              <>
                <Nav />
                <CareerAssessment />
                <Footer />
              </>
            }
          /> */}

          <Route
            path="/riasec"
            element={
              <>
                <Nav />
                <Raisec />
                <Footer />
              </>
            }
          />
          <Route
            path="/baronmodel"
            element={
              <>
                <Nav />
                <Baronmodel />
                <Footer />
              </>
            }
          />
          <Route
            path="/core"
            element={
              <>
                <Nav />
                <Core/>
                <Footer />
              </>
            }
          />

            <Route
            path="/Dat"
            element={
              <>
                <Nav />
                <Dat/>
                <Footer />
              </>
            }
          />
          {/* Terms & Conditions */}
          <Route
            path="/terms-and-conditions"
            element={
              <>
                <Nav />
                <TnC />
                <Footer />
              </>
            }
          />

          {/* Privacy Policy */}
          <Route
            path="/privacy-policy"
            element={
              <>
                <Nav />
                <PrivacyPolicy />
                <Footer />
              </>
            }
          />

          {/* NextGen Innovator */}
          <Route
            path="/nextgeni"
            element={
              <>
                <Nav />
                <Nextgen />
                <Footer />
              </>
            }
          />

          {/* About Us */}
          <Route
            path="/about-us"
            element={
              <>
                <Nav />
                <AboutUs />
                <Footer />
              </>
            }
          />

          {/* About Our Value */}
          <Route
            path="/about-ourvalue"
            element={
              <>
                <Nav />
                <AboutOurValue />
                <Footer />
              </>
            }
          />

          {/* NextGen Juniors */}
          <Route
            path="/nextgenj"
            element={
              <>
                <Nav />
                <NextgenJuniors />
                <Footer />
              </>
            }
          />

          {/* Contact Us */}
          <Route
            path="/contact"
            element={
              <>
                <Nav />
                <Contact_Us />
                <Footer />
              </>
            }
          />

          {/* Blog */}
          <Route
            path="/blog"
            element={
              <>
                <Nav />
                <Blog />
                <Footer />
              </>
            }
          />

          {/* Describe Story */}

          <Route
            path="/login"
            element={
              <>
                <Nav />
                <Login />
                <Footer />
              </>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/blogregisterpage"
            element={
              <ProtectedRoute>
                <BlogRegister />
              </ProtectedRoute>
            }
          />
          <Route
            path="/registertestimonial"
            element={
              <ProtectedRoute>
                <Testimonialsumbit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/registerfaq"
            element={
              <ProtectedRoute>
                <FaqregisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/registerjobs"
            element={
              <ProtectedRoute>
                <JobregisterPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stem"
            element={
              <>
                <Nav />
                <SteamPage_main />
                <Footer />
              </>
            }
          />
          {/* <Route
            path="/sample"
            element={
              <>
                
                <Sample />
               
              </>
            }
          /> */}
        </Routes>
      </Router>
     
    </>
  );
}

export default App;





